import { render } from "./fee-records.vue?vue&type=template&id=1f9901b4"
import script from "./fee-records.vue?vue&type=script&lang=js"
export * from "./fee-records.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__